var _a;
// src/interceptors/axiosConfig.ts
import axiosDefault from "axios";
import * as axiosModule from "axios";
import { authRequestErrorInterceptor, authRequestInterceptor, authResponseErrorInterceptor, } from "./authHeaderInterceptor";
export var API_BASE_URL = window._env_.REACT_APP_SIGNO_API_URL;
export var APP_MOCK = window._env_.REACT_APP_MOCK;
export var APP_ENABLE_CONSOLE_LOGGING = window._env_.REACT_APP_ENABLE_CONSOLE_LOGGING;
export var APP_ENV = window._env_.REACT_APP_ENV;
export var APP_VERSION = window._env_.REACT_APP_VERSION;
var axiosClient = ((_a = axiosModule.default) !== null && _a !== void 0 ? _a : axiosDefault);
var axiosInstance = axiosClient.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});
axiosInstance.interceptors.request.use(authRequestInterceptor, authRequestErrorInterceptor);
axiosInstance.interceptors.response.use(function (response) { return response; }, authResponseErrorInterceptor);
export default axiosInstance;
